export default __webpack_public_path__ + "static/media/DSCN6690.52eb6882.jpg";